import api from '@/api'

export default {
  namespaced: true,
  state: {
    products: [],
    wishlistInfo: {},
    isLoading: false
  },
  getters: {
    wishlistQuantity ({ wishlistInfo }) {
      if (!wishlistInfo) return null

      return wishlistInfo.goods_all ? wishlistInfo.goods_all : null
    },
    productsIdsInWishlist ({ wishlistInfo }) {
      if (!wishlistInfo) return []

      return wishlistInfo.products_ids ? wishlistInfo.products_ids : []
    },
    productsForRender ({ products }, { productsIdsInWishlist }) {
      if (!products) return []

      return products.filter(x => productsIdsInWishlist.includes(x.id))
    }
  },
  mutations: {
    SET_WISHLIST_INFO (state, info) {
      state.products = [...state.products, ...info.products]
      state.wishlistInfo = info
    },
    SET_SHORT_WISHLIST_INFO (state, info) {
      state.wishlistInfo = { ...state.wishlistInfo, ...info }
    },
    SET_IS_LOADING (state, bool) {
      state.isLoading = bool
    },
    RESET_WISHLIST_INFO (state) {
      state.products = []
      state.wishlistInfo.offset = 0
    }
  },
  actions: {
    GET_WISHLIST_INFO ({ commit, state }) {
      const params = {}

      if (state.wishlistInfo?.offset) params.offset = state.wishlistInfo.offset

      commit('SET_IS_LOADING', true)

      api.cabinet.getWishlist(params)
        .then(res => {
          if (res.status === 'success') {
            commit('SET_WISHLIST_INFO', res)
          }
        })
        // .catch(err => {
        //   console.log(err)
        // })
        .finally(() => {
          commit('SET_IS_LOADING', false)
        })
    },
    CHANGE_WISH_LIST_STATUS: ({ commit, state, getters }, payload) => {
      return new Promise((resolve, reject) => {
        const url = getters.productsIdsInWishlist.includes(payload.id) ? `/cabinet/wishlist/delete/?id=${payload.id}` : `/cabinet/wishlist/add/?id=${payload.id}`

        api.cabinet.changeWishlistStatus(url)
          .then(res => {
            if (res.success) {
              commit('SET_SHORT_WISHLIST_INFO', res.wishlist)
              resolve(res)
            } else {
              reject(res.message)
            }
          })
          .catch(error => reject(error))
      })
    },
    SET_SHORT_WISHLIST_INFO_ACTION ({ commit }, info) {
      commit('SET_SHORT_WISHLIST_INFO', info)
    },
    RESET_WISHLIST_INFO_ACTION ({ commit }) {
      commit('RESET_WISHLIST_INFO')
    }
  }
}
